import * as React from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import { Box, CircularProgress } from '@mui/material'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'
import { LoadingButton } from '@mui/lab'

interface Props {
  title: string
  contentText: string
  buttonConfirmText: string
  buttonCancel: string
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  setConfirm: React.Dispatch<React.SetStateAction<boolean>>
  open: boolean
  loadingModalButton: boolean
  loadingMessage: boolean
  styleDialogContentTex: any
}

export const ConfirmationDialog: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  contentText,
  buttonConfirmText,
  buttonCancel,
  setOpen,
  setConfirm,
  open,
  loadingModalButton,
  loadingMessage = false,
  styleDialogContentTex = null
}) => {
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={() => {
          setOpen(false)
          setConfirm(false)
        }}
        aria-labelledby='responsive-dialog-title'
      >
        {loadingMessage ? (
          <Box
            display={'flex'}
            justifyContent={'center'}
            alignItems={'center'}
            width={'400px'}
            height={'200px'}
          >
            <CircularProgress />
          </Box>
        ) : (
          <>
            <DialogTitle id='responsive-dialog-title'>{title}</DialogTitle>
            <DialogContent>
              <DialogContentText style={styleDialogContentTex}>{contentText}</DialogContentText>
            </DialogContent>
          </>
        )}
        <DialogActions style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
          <Button
            color='error'
            variant='contained'
            onClick={() => {
              setOpen(false)
              setConfirm(false)
            }}
            autoFocus
          >
            {buttonCancel}
          </Button>
          { buttonConfirmText && 
            <LoadingButton
              variant='contained'
              onClick={() => setConfirm(true)}
              loading={loadingModalButton}
              disabled={loadingMessage}
            >
              {buttonConfirmText}
            </LoadingButton>
          }
        </DialogActions>
      </Dialog>
    </div>
  )
}
